import Link from 'next/link';
import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div``;

export const Packages = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: ${rem(0)};
    padding-bottom: ${rem(60)};

    @media (min-width: ${breakpoints.md}px) {
        margin-top: ${rem(80)};
    }

    @media (min-width: ${breakpoints.lg}px) {
        justify-content: space-between;
    }
`;

export const Package = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 ${rem(25)};
    width: 100%;
    margin: ${rem(120)} ${rem(20)} 0 ${rem(20)};
    position: relative;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${rem(12)};
    position: relative;

    @media (min-width: ${breakpoints.xs}px) {
        max-width: ${rem(460)};
    }

    @media (min-width: ${breakpoints.md}px) {
        max-width: 31%;
        margin: 1%;
    }
`;

export const PackageImage = styled.img`
    width: ${rem(200)};
    margin: -${rem(100)} auto 0 10%;
`;

export const GarantSection = styled.div`
    position: absolute;
    right: ${rem(10)};
    top: ${rem(10)};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const GarantImage = styled.img`
    width: ${rem(65)};
`;

export const GarantLabel = styled.span`
    font-size: ${({ theme }) => theme.fontSizes.textSmall};
    margin-top: ${rem(8)};
    color: ${({ theme }) => theme.colors.grey};
`;

export const PackageLabel = styled.span`
    display: block;
    margin-top: ${rem(4)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    padding-left: ${rem(50)};
`;

export const PackageTitle = styled(Link)`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    display: flex;
    align-items: center;
    gap: ${rem(10)};
    margin: ${rem(10)} 0 ${rem(5)} 0;
    font-size: ${({ theme }) => theme.fontSizes.h5};

    &:hover,
    &:focus-visible {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export const PackagePriceSection = styled.div`
    text-align: center;
`;

export const PackagePrice = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: 1rem;
`;

export const PackagePriceWithoutVat = styled.span`
    display: block;
    padding-top: ${rem(10)};
    font-size: ${({ theme }) => theme.fontSizes.h6};
`;

export const PackageDescriptionList = styled.ul`
    padding: ${rem(25)} 0 ${rem(20)} ${rem(5)};
`;

export const PackageDescriptionItem = styled.li`
    margin-bottom: ${rem(15)};
    color: ${({ theme }) => theme.colors.secondaryGrey};
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(28)};
    list-style: none;
    display: flex;

    svg {
        width: ${rem(25)};
        height: ${rem(25)};
        margin-right: ${rem(5)};
        margin-top: ${rem(2)};

        g polyline {
            stroke: ${({ theme }) => theme.colors.black};
        }
    }

    a {
        color: ${({ theme }) => theme.colors.primary};
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
    }

    .bold {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.black};
    }
`;
